import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useAuthContext } from "../../../hooks/useAuthContext";
import eventsAPI from "../../../services/events";
import MeaPageTitle from "../../../components/MeaPageTitle";
import EventDetailComponent from "./components/EventDetailComponent";
import MeaPageHeader from "../../../components/MeaPageHeader";
import EventDetailExtraComponent from "./components/EventDetailExtraComponent";
import { useRef } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import UpdateEventModal from "./components/UpdateEventModal";
import { PERMISSION_TRAINING_EVENTS } from "../../../permissions";

const EventDetailPage = () => {
  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const toast = useRef();
  const navigate = useNavigate();
  const eventId = params.eventId;
  //
  const eventQuery = eventsAPI.GetOne(schoolId, trainingId, accessToken, eventId);
  const eventObj = eventQuery?.data?.data;
  //
  //
  return (
    <>
      <MeaPage
        showBackButton={true}
        title={<MeaPageTitle prefix={"Évènement:"} title={eventObj?.name} />}
        actions={[
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            disable: !hasPermission(PERMISSION_TRAINING_EVENTS.UPDATE),
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  eventQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_EVENTS.UPDATE),
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_EVENTS.DELETE),
            command: () => {
              confirmDialog({
                message: 'Voulez-vous vraiment supprimer cette évenement?',
                header: 'Confirmation',
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  eventsAPI.DeleteOne(schoolId, trainingId, accessToken, eventId)
                    .then(data => {
                      toast.current.show({ severity: 'success', summary: 'Succès', detail: eventObj?.name + " Supprimé!", life: 3000 });
                      navigate("/school/" + schoolId + "/admin/trainings/" + trainingId + "/events");
                    })
                    .catch(error => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              })
            }
          },
        ]}
      >
        <MeaPageHeader>
          <EventDetailComponent event={eventObj} />
          <EventDetailExtraComponent event={eventObj} />
        </MeaPageHeader>

        <UpdateEventModal ref={updateModalRef} event={eventObj} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
        <ConfirmDialog />
        <Toast ref={toast} />
      </MeaPage>
    </>
  );
};
export default EventDetailPage;
